import React from 'react';
export default function FrogHatSvg({ size = 40 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      {/* Frog body */}
      <ellipse cx="20" cy="22" rx="14" ry="10" fill="#66BB6A" />
      {/* Belly */}
      <ellipse cx="20" cy="24" rx="10" ry="7" fill="#A5D6A7" />

      {/* Big bulging eyes */}
      <circle cx="12" cy="10" r="6" fill="#66BB6A" />
      <circle cx="28" cy="10" r="6" fill="#66BB6A" />
      {/* Eye whites */}
      <circle cx="12" cy="9" r="4.5" fill="#F5F5F0" />
      <circle cx="28" cy="9" r="4.5" fill="#F5F5F0" />
      {/* Pupils */}
      <circle cx="13" cy="9" r="2.5" fill="#2E7D32" />
      <circle cx="29" cy="9" r="2.5" fill="#2E7D32" />
      <circle cx="13" cy="9" r="1.2" fill="#1B5E20" />
      <circle cx="29" cy="9" r="1.2" fill="#1B5E20" />
      {/* Eye shine */}
      <circle cx="11.5" cy="7.5" r="1" fill="white" opacity="0.7" />
      <circle cx="27.5" cy="7.5" r="1" fill="white" opacity="0.7" />

      {/* Cute mouth */}
      <path d="M14 22 C16 24 24 24 26 22" stroke="#2E7D32" strokeWidth="1.2" fill="none" strokeLinecap="round" />

      {/* Nostrils */}
      <circle cx="17" cy="19" r="0.8" fill="#2E7D32" />
      <circle cx="23" cy="19" r="0.8" fill="#2E7D32" />

      {/* Left webbed foot draping down */}
      <path d="M8 30 L4 36 M8 30 L6 37 M8 30 L8 37" stroke="#4CAF50" strokeWidth="1.5" fill="none" strokeLinecap="round" />
      <path d="M4 36 C3 37 5 38 6 37 C6 38 7 38 8 37" fill="#4CAF50" />

      {/* Right webbed foot draping down */}
      <path d="M32 30 L36 36 M32 30 L34 37 M32 30 L32 37" stroke="#4CAF50" strokeWidth="1.5" fill="none" strokeLinecap="round" />
      <path d="M36 36 C37 37 35 38 34 37 C34 38 33 38 32 37" fill="#4CAF50" />

      {/* Spots */}
      <circle cx="14" cy="24" r="1.5" fill="#4CAF50" opacity="0.5" />
      <circle cx="26" cy="22" r="1.2" fill="#4CAF50" opacity="0.5" />
      <circle cx="20" cy="18" r="1" fill="#4CAF50" opacity="0.4" />
    </svg>
  );
}
